import styled from 'styled-components';

import RecoverPaymentButton from '../RecoveryPaymentButton.styles';

export const ChangePaymentMethodButton = styled(RecoverPaymentButton)`
  margin: 0.4rem 0px;
`;

export default ChangePaymentMethodButton;
